import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { BaseService } from '@aifs-shared/common/base-service';
import { ResponseData } from '@aifs-shared/common/response-data';
import { BaseResponse } from '@aifs-shared/common/base-response';

import { Observable, Subject } from 'rxjs';

import { Message, MessageType } from './message';
import { environment } from '@environments/environment';
import { ConversationHeader } from './conversation-header';
import { UserService } from '@aifs-shared/user/user.service';

@Injectable()
export class MessageService extends BaseService {

    constructor(private http: HttpClient, private userService: UserService) {
        super();
    }

    public getUnreadMessageCount(): Observable<number> {
        var subject = new Subject<number>();

        this.http
            .get<BaseResponse>(environment.ServiceUrl_Message_GetUnread)
            .subscribe(
                data => {
                    const result = this.getResultData<GetUnreadMessageCountResponse>(data);
                    subject.next(result.unread);
                },
                error => {
                    this.handleError(error);
                });

        return subject;
    }

    public getMessages(forMailboxType: MessageType): Observable<GetMessageResponse> {
        if (forMailboxType == MessageType.Received)
            return this.getReceivedMessages();

        return this.getSentMessages();
    }

    public setMessageRead(id: number): Observable<any> {
        let subject = new Subject<any>();

        this.http
            .post<BaseResponse>(`${environment.ServiceUrl_Message_MarkRead(id)}`, null)
            .subscribe(
                data => {
                    let response = data.resultCode;
                    if (data.resultCode == 1)
                        subject.next(response);
                    else
                        subject.error(data.error);
                },
                error => {
                    this.handleError(error);
                });

        return subject;
    }

    public sendReplyTo(id: number, replyText: string): Observable<any> {
        let subject = new Subject<any>();

        this.http
            .post<BaseResponse>(`${environment.ServiceUrl_Message_PostReply(id)}`,
                { "body": replyText })
            .subscribe({
                next: (data: any) => {
                    let response = data.resultCode;
                    if (data.resultCode == 1)
                        subject.next(response);
                    else
                        subject.error(data.error);
                },
                error: (error) => {
                    this.handleError(error);
                }
            });

        return subject;
    }



    getConversationHeaders(): Observable<GetConversationHeadersResponse> {
        let subject = new Subject<GetConversationHeadersResponse>();

        this.http
            .get<BaseResponse>(environment.ServiceUrl_Message_Headers)
            .subscribe(
                data => {
                    let response = this.getResultData<GetConversationHeadersResponse>(data, false);
                    subject.next(response);
                },
                error => {
                    this.handleError(error);
                });

        return subject;
    }

    getFullConversationWith(interlocutorUserId: number) {
        let subject = new Subject<GetMessageResponse>();

        this.http
            .get<BaseResponse>(environment.ServiceUrl_Message_GetFullConversation(interlocutorUserId))
            .subscribe({
                next: (data: any) => {
                    let response = this.getResultData<GetMessageResponse>(data, false);
                    subject.next(response);
                },
                error: (error: any) => {
                    this.handleError(error);
                }
            });

        return subject;
    }

    getReceivedMessages(): Observable<GetMessageResponse> {
        let subject = new Subject<GetMessageResponse>();

        this.http
            .get<BaseResponse>(environment.ServiceUrl_Message_GetReceived)
            .subscribe({
                next: (data: any) => {
                    let response = this.getResultData<GetMessageResponse>(data, false);
                    subject.next(response);
                },
                error: (error: any) => {
                    this.handleError(error);
                }
            });

        return subject;
    }

    getSentMessages(): Observable<GetMessageResponse> {
        let subject = new Subject<GetMessageResponse>();

        this.http
            .get<BaseResponse>(environment.ServiceUrl_Message_GetSent)
            .subscribe({
                next: (data: any) => {
                    let response = this.getResultData<GetMessageResponse>(data, false);
                    subject.next(response);
                },
                error: (error: any) => {
                    this.handleError(error);
                }
            });

        return subject;
    }

    storeMessagePassthrough(userId: number, profileUrl: string | undefined, name: string) {
        const m = new MessageOpenConversationPassthrough(userId, profileUrl, name);
        sessionStorage.setItem('cmp', JSON.stringify(m));
    }

    retrieveMessagePassthrough(): MessageOpenConversationPassthrough | undefined {
        const v = sessionStorage.getItem('cmp');
        if (v) {
            const m: MessageOpenConversationPassthrough = JSON.parse(v);
            return m;
        }
        return undefined;
    }




}

export class GetUnreadMessageCountResponse implements ResponseData {
    unread: number = 0;
}

export class GetMessageResponse implements ResponseData {
    messages?: Message[];
}

export class GetConversationHeadersResponse implements ResponseData {
    conversationHeaders?: ConversationHeader[];
}



export class MessageOpenConversationPassthrough {
    userId: number;
    profileUrl: string | undefined;
    name: string;
    constructor(userId: number, profileUrl: string | undefined, name: string) {
        this.userId = userId;
        this.profileUrl = profileUrl;
        this.name = name;
    }
}
